import { Banner, BlockStack, Button, InlineStack, Text } from '@shopify/polaris';
export type DraftStatus = {
  saved: boolean; stale: boolean; error: string; changedElsewhere: boolean;
  clear: () => void; useSaved: () => void; retrySave: () => void;
};
export function DraftNotice({ draft, locked = false }: { draft: DraftStatus; locked?: boolean }) {
  return <BlockStack gap="300">
    <Text as="p">Unsent entries stay in this browser for this account and company. They do not change warehouse records. Review them before saving.</Text>
    {draft.error && <Banner tone="critical">{draft.error}</Banner>}
    {draft.stale && <Banner tone="warning">The warehouse record changed since this draft. Load the saved entries only if you will check every value against the current record.</Banner>}
    <InlineStack gap="200">
      {draft.stale && <Button disabled={locked} onClick={draft.useSaved}>Load saved entries for review</Button>}
      {draft.error && !draft.stale && !draft.changedElsewhere && <Button disabled={locked} onClick={draft.retrySave}>Retry saving browser draft</Button>}
      {(draft.saved || draft.error) && <Button disabled={locked || draft.changedElsewhere} onClick={draft.clear}>Discard browser draft</Button>}
    </InlineStack>
  </BlockStack>;
}
